import React from 'react';

export const TrashIcon = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M14.1668 2.33203V14.9987C14.1668 15.1755 14.0966 15.3451 13.9716 15.4701C13.8465 15.5951 13.677 15.6654 13.5002 15.6654H3.50016C3.32335 15.6654 3.15378 15.5951 3.02876 15.4701C2.90373 15.3451 2.8335 15.1755 2.8335 14.9987V2.33203"
        stroke="#4B4B4B"
      />
      <path
        d="M5.5 2.33203V0.998698C5.5 0.821887 5.57024 0.652318 5.69526 0.527293C5.82029 0.402269 5.98986 0.332031 6.16667 0.332031H10.8333C11.0101 0.332031 11.1797 0.402269 11.3047 0.527293C11.4298 0.652318 11.5 0.821887 11.5 0.998698V2.33203"
        stroke="#4B4B4B"
      />
      <path d="M0.833496 2.33203H16.1668" stroke="#4B4B4B" />
    </g>
  </svg>
);
